import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider, LANGS, ROUTES } from "@/i18n/LangContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { Seo } from "@/components/Seo";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import NotFoundPage from "@/pages/NotFoundPage";

function LangLayout() {
  const { lang } = useParams();
  if (!LANGS.includes(lang)) return <Navigate to="/fr" replace />;
  return (
    <LangProvider lang={lang}>
      <Seo />
      <Header />
      <main id="main">
        <Routes>
          <Route index element={<HomePage />} />
          <Route path={ROUTES.services[lang]} element={<ServicesPage />} />
          <Route path={ROUTES.about[lang]} element={<AboutPage />} />
          <Route path={ROUTES.contact[lang]} element={<ContactPage />} />
          <Route path={ROUTES.terms[lang]} element={<LegalPage doc="terms" />} />
          <Route path={ROUTES.legal[lang]} element={<LegalPage doc="legal" />} />
          <Route path={ROUTES.privacy[lang]} element={<LegalPage doc="privacy" />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </LangProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Navigate to="/fr" replace />} />
          <Route path="/:lang/*" element={<LangLayout />} />
        </Routes>
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
